var map = {
	"./europa_logo": 3,
	"./europa_logo.jpg": 3,
	"./img": 4,
	"./img.jpg": 4,
	"./lgt/gallery1": 5,
	"./lgt/gallery1.jpg": 5,
	"./lgt/gallery2": 6,
	"./lgt/gallery2.jpg": 6,
	"./lgt/gallery3": 7,
	"./lgt/gallery3.jpg": 7,
	"./lgt/gallery4": 8,
	"./lgt/gallery4.jpg": 8,
	"./lgt/lgt_2": 9,
	"./lgt/lgt_2.jpg": 9,
	"./main/New-Art-animation": 10,
	"./main/New-Art-animation.gif": 10,
	"./main/bedtime": 11,
	"./main/bedtime.jpg": 11,
	"./main/botanic": 12,
	"./main/botanic.jpg": 12,
	"./main/k3": 13,
	"./main/k3.jpg": 13,
	"./main/k4": 14,
	"./main/k4.jpg": 14,
	"./main/k5": 15,
	"./main/k5.jpg": 15,
	"./main/k6": 16,
	"./main/k6.jpg": 16,
	"./main/k7": 17,
	"./main/k7.jpg": 17,
	"./main/k8": 18,
	"./main/k8.jpg": 18,
	"./main/k9": 19,
	"./main/k9.jpg": 19,
	"./main/karacsony": 20,
	"./main/karacsony.jpg": 20,
	"./main/work1": 21,
	"./main/work1.jpg": 21,
	"./main/work12": 22,
	"./main/work12.jpg": 22,
	"./main/work2": 23,
	"./main/work2.jpg": 23,
	"./main/work3": 24,
	"./main/work3.jpg": 24,
	"./social/vv_01": 25,
	"./social/vv_01.jpg": 25,
	"./social/vv_03": 26,
	"./social/vv_03.jpg": 26,
	"./social/vv_05": 27,
	"./social/vv_05.jpg": 27,
	"./social/vv_07": 28,
	"./social/vv_07.jpg": 28,
	"./stamps/vedett_allatok": 29,
	"./stamps/vedett_allatok.jpg": 29,
	"./t_logo": 30,
	"./t_logo.svg": 30,
	"./tibor": 31,
	"./tibor.svg": 31,
	"./vedett_allatok/Vedett-belyeg_0000__": 32,
	"./vedett_allatok/Vedett-belyeg_0000__.png": 32,
	"./vedett_allatok/Vedett-blokk_0000__": 33,
	"./vedett_allatok/Vedett-blokk_0000__.png": 33,
	"./vedett_allatok/Vedett_dupla": 34,
	"./vedett_allatok/Vedett_dupla.jpg": 34,
	"./vedett_allatok/vedett1": 35,
	"./vedett_allatok/vedett1.jpg": 35,
	"./vedett_allatok/vedett2": 36,
	"./vedett_allatok/vedett2.jpg": 36,
	"./vedett_allatok/vedett3": 37,
	"./vedett_allatok/vedett3.jpg": 37,
	"./vedett_allatok/vedett4": 38,
	"./vedett_allatok/vedett4.jpg": 38,
	"./vedett_allatok/vedett5": 39,
	"./vedett_allatok/vedett5.jpg": 39,
	"./vedett_allatok/vedett6": 40,
	"./vedett_allatok/vedett6.jpg": 40,
	"./vedett_allatok/vedett7": 41,
	"./vedett_allatok/vedett7.jpg": 41,
	"./vedett_allatok/vedett8": 42,
	"./vedett_allatok/vedett8.jpg": 42,
	"./work_tibor": 43,
	"./work_tibor.png": 43,
	"./work_vml": 44,
	"./work_vml.jpg": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;